import { _ } from "src/services";
import { Facebook, Telegram, Twitter } from "../svg";

export const ShareSocials = [
    {
        url: (url: string, title?: string) => `https://telegram.me/share/url?url=${url}&text=${title}`,
        title: () => _("telegram"),
        icon: () => (<Telegram />)
    },
    {
        url: (url: string, title?: string) => `https://twitter.com/intent/tweet?url=${url}&text=${title}&hashtags=video_streaming=`,
        title: () => _("twiiter"),
        icon: () => (<Twitter />)
    },
    {
        url: (url: string, title?: string) => `https://www.facebook.com/sharer.php?u=${url}`,
        title: () => _("facebook"),
        icon: () => (<Facebook />)
    }
];